import { IContractSchema } from '../definitions/ContractSchema'
import { IContractIngestionRequest } from '../definitions/ContractIngestionRequest'
import ApiClient from '../backend/ApiClient'
import { IClassifiedFeature } from '../definitions/Classification'
import affirm from '../core/Affirm'
import { ISystemConfigsCollection } from '../definitions/Common'
import GroupsManager from './GroupsManager'

const POLL_MS = 10_000
const delay = (ms: number) => new Promise(r => setTimeout(r, ms))

export interface OrchestratorResult {
    aiFeatures: IClassifiedFeature[]
    status: 'SUCCEEDED' | 'FAILED' | 'TIMED_OUT'
    executionArn: string
}

class OrchestratorAIManagerClass {
    run = async (fileUris: string[], contractSchema: IContractSchema, systemConfigsCollection: ISystemConfigsCollection[], onProgress?: (s: 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'TIMED_OUT') => void): Promise<OrchestratorResult> => {
        affirm(Array.isArray(fileUris) && fileUris.length > 0, 'At least one fileUri is required')
        affirm(contractSchema, 'contractSchema is required')
        affirm(systemConfigsCollection, 'systemConfigsCollection is required')

        const groups = GroupsManager.transformSchemaToFeatureGroups(contractSchema, systemConfigsCollection)

        const payload: IContractIngestionRequest = {
            fileUris,
            confidenceThreshold: 0.9,
            temperature: 0,
            groups
        }

        const { executionArn } = await ApiClient.ContractIngestion.startOrchestrator(payload)

        let res = await ApiClient.ContractIngestion.getExecutionResult(executionArn)
        let status: 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'TIMED_OUT' = res.status

        if (status !== 'RUNNING') {
            return {
                aiFeatures: status === 'SUCCEEDED'
                    ? (res.output?.finalResults ?? []) as IClassifiedFeature[]
                    : null,
                status,
                executionArn
            }
        }

        if (onProgress) onProgress(status)

        let output: any = null

        while (status === 'RUNNING') {
            await delay(POLL_MS)

            res = await ApiClient.ContractIngestion.getExecutionResult(executionArn)
            status = res.status

            if (onProgress) onProgress(status)
            if (status === 'SUCCEEDED') {
                const final = (res.output?.finalResults ?? []) as IClassifiedFeature[]
                output = final
            }
        }

        return { aiFeatures: output, status, executionArn }
    }
}

const OrchestratorAIManager = new OrchestratorAIManagerClass()
export default OrchestratorAIManager
